import Button from '../../atoms/Button/Button';
import { useHistory } from 'react-router-dom';

const NoPermission = ({ logout }) => {
  const history = useHistory();

  const logoutWithRedirect = () => {
    history.push('/items-list');
    logout();
  };
  return (
    <div style={{ textAlign: 'center' }}>
      <h1>You do not have permission to see any process on this panel.</h1>
      <p> Contact your project’s manager.</p>
      <Button
        white
        onClick={logoutWithRedirect}
        fullWidth
        variant="contained"
        color="primary"
        sx={{ mt: 3, mb: 2, width: 200 }}
      >
        Logout
      </Button>
    </div>
  );
};

export default NoPermission;
